module.exports = __webpack_public_path__ + "img/youtube.5b252e1f.png";